import React from "react";
import { createPortal } from "react-dom";

/**
 * Modal reutilizable (estilo Bootstrap).
 * Se renderiza en document.body para evitar problemas de z-index/stacking dentro del layout.
 */
export default function Modal({
	title,
	open,
	onClose,
	children,
	footer,
	dialogClassName,
	nested,
}) {
	const overlay = !open ? null : (
		<div
			className="modal d-block"
			tabIndex={-1}
			role="dialog"
			style={{
				position: "fixed",
				inset: 0,
				zIndex: nested ? 1080 : 1060,
				backgroundColor: "rgba(0,0,0,.5)",
			}}
			onMouseDown={(e) => {
				if (e.target === e.currentTarget) onClose();
			}}
		>
			<div
				className={dialogClassName ?? "modal-dialog modal-lg"}
				role="document"
			>
				<div className="modal-content shadow">
					<div className="modal-header">
						<h5 className="modal-title">{title}</h5>
						<button type="button" className="btn-close" onClick={onClose} aria-label="Cerrar" />
					</div>

					<div className="modal-body">{children}</div>

					{footer && <div className="modal-footer">{footer}</div>}
				</div>
			</div>
		</div>
	);

	return overlay ? createPortal(overlay, document.body) : null;
}